"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offerLinkAttributes = void 0;

var _isPlsUrl = require("./is-pls-url");

var offerLinkAttributes = function offerLinkAttributes(href) {
  if (!href) {
    return {};
  }

  if ((0, _isPlsUrl.isPlsUrl)(href)) {
    return {
      href: href,
      rel: 'noopener',
      referrerPolicy: 'no-referrer-when-downgrade'
    };
  }

  return {
    href: href,
    rel: 'noopener noreferrer'
  };
};

exports.offerLinkAttributes = offerLinkAttributes;
//# sourceMappingURL=offer-link-attributes.js.map